import { gql } from '@apollo/client'

export const GET_LIST_QUESTION_PASSAGE_BANK = gql`
  query findAllQuestionPassageBank($params: QuestionPassageBankQueryInput = {}) {
    findAllQuestionPassageBankCMS(query: $params) {
      count
      items {
        id
        subject {
          id
          slug
          tabName
        }
        level
        title
        isLive
        order
        passageTime
        wpm
        questionPassagesIds
      }
    }
  }
`

export const GET_ONE_QUESTION_PASSAGE_BANK = gql`
  query findOneQuestionPassageBank($params: String!) {
    findOneQuestionPassageBank(id: $params) {
      id
      subject {
        id
        slug
        tabName
      }
      level
      title
      isLive
      order
      passageTime
      wpm
      questionPassagesIds
      questionPassages {
        id
        subject {
          id
          slug
          tabName
        }
        level
        title
        content
      }
      history {
        updatedAt
        updatedBy
      }
      createdAt
      updatedAt
    }
  }
`

export const CREATE_QUESTION_PASSAGE_BANK = gql`
  mutation createQuestionPassageBank($params: CreateQuestionPassageBankInput!) {
    createQuestionPassageBank(createQuestionPassageBankInput: $params) {
      id
    }
  }
`

export const UPDATE_QUESTION_PASSAGE_BANK = gql`
  mutation updateQuestionPassageBank($params: UpdateQuestionPassageBankInput!) {
    updateQuestionPassageBank(updateQuestionPassageBankInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_QUESTION_PASSAGE_BANK = gql`
  mutation removeQuestionPassageBank($params: String!) {
    removeQuestionPassageBank(id: $params) {
      affected
    }
  }
`
